export class ProjectAlreadyExistsMessage {
    public name: string;
    
    constructor(name: string)
    {
        this.name = name;
    }
}